module.exports = __webpack_public_path__ + "static/media/Mountain Biker.414031ce.jpg";